(function () {
  'use strict';

  var root = document.querySelector('[data-cc-text-engraving]');
  if (!root) return;

  var multi = root.hasAttribute('data-multi');
  var required = root.hasAttribute('data-required');
  var maxChars = parseInt(root.dataset.maxChars, 10) || 12;
  var minSlots = parseInt(root.dataset.minSlots, 10) || 1;
  var maxSlots = parseInt(root.dataset.maxSlots, 10) || 5;
  var prefix = root.dataset.prefix || 'Slot';
  var charset = root.dataset.charset || 'any';
  var caseMode = (root.dataset.case || '').toLowerCase();
  var label = root.dataset.label || 'Engraving';
  var property = root.dataset.property || label;

  // Variable-length single-box mode (see the Liquid block's comment): maxChars
  // is whatever the customer's chosen count currently allows, never more than
  // the configured ceiling. maxCharsAxis is '' in every other mode, which keeps
  // all of the behaviour below inert for them.
  var maxCharsCeiling = maxChars;
  var maxCharsAxis = root.getAttribute('data-cc-maxchars-from-variant') || '';
  // Characters allowed on top of the purchased count — a separator the shopper
  // types but doesn't pay for (Bubble Drop's clasp "-"). Counted in the counter
  // total, so "0/4" on a 3-letter necklace reads as 3 letters plus the dash.
  var maxCharsBonus = parseInt(root.dataset.maxcharsVariantBonus, 10) || 0;
  var bonusChar = root.dataset.maxcharsBonusChar || '-';

  // Spend the budget the way the shopper paid for it: real characters are
  // capped at the purchased count, and the bonus buys ONLY bonusChar. Without
  // the split a "+1 for the clasp dash" allowance is simply a free extra
  // letter — six letters at the five-letter price — which is the same class of
  // bug as the fixed maxlength this mode replaced. Characters past either
  // budget are dropped rather than truncating the whole string, so an existing
  // trailing dash survives when the count is lowered.
  function enforceBudget(value) {
    if (!maxCharsAxis || maxCharsBonus <= 0) {
      return value.length > maxChars ? value.slice(0, maxChars) : value;
    }
    var letterBudget = maxChars - maxCharsBonus;
    var bonusBudget = maxCharsBonus;
    var out = '';
    for (var i = 0; i < value.length; i++) {
      var ch = value.charAt(i);
      if (ch === bonusChar) {
        if (bonusBudget <= 0) continue;
        bonusBudget--;
      } else {
        if (letterBudget <= 0) continue;
        letterBudget--;
      }
      out += ch;
    }
    return out;
  }
  var effectiveMax = parseInt(root.dataset.effectiveMaxChars, 10);
  if (maxCharsAxis && effectiveMax > 0) maxChars = Math.min(effectiveMax, maxCharsCeiling);

  // Spaces are allowed in EVERY mode. Multi-slot used to strip them because all
  // the slots were space-joined into one property, so an inner space made the
  // list unparseable. Under Alex's numbered format each slot posts its own
  // property, so nothing is joined and a two-word name like "Jo Ann" must
  // survive verbatim. Hyphens always allowed.
  function filterValue(value) {
    var out = value;
    if (charset === 'letters_only') {
      out = out.replace(/[^a-zA-Z\- ]/g, '');
    } else if (charset === 'alphanumeric') {
      out = out.replace(/[^a-zA-Z0-9\- ]/g, '');
    }
    // block_config's `case` was previously declared but never applied, so an
    // "upper" product shipped whatever the shopper typed. Forced on the VALUE,
    // not via CSS text-transform, because the cart stores the value.
    if (caseMode === 'upper') out = out.toUpperCase();
    else if (caseMode === 'lower') out = out.toLowerCase();
    return out;
  }

  function dispatch(values) {
    var filled = values.filter(function (v) { return v.trim() !== ''; }).length;
    document.dispatchEvent(new CustomEvent('cc:engraving-changed', {
      detail: {
        property: property,
        label: label,
        values: values.slice(),
        filled: filled,
        min: multi ? minSlots : 1,
        required: required
      }
    }));
  }

  function setCounterState(counterEl, len) {
    counterEl.textContent = len + '/' + maxChars + ' characters';
    counterEl.classList.toggle('is-warning', len > maxChars * 0.8 && len < maxChars);
    counterEl.classList.toggle('is-full', len >= maxChars);
  }

  // A blank engraving posts NO key at all rather than an empty string — same
  // contract as the gift/Diamond toggles and designer notes. window.ccSubmitWhenFilled
  // (cc-join.js) is the ONE implementation; it gates by form ownership rather
  // than by touching the name attribute, which would break Pipeline's cached
  // serialiser and freeze the variant id. Used by all three modes below (single,
  // multi-slot, count-first) on whichever control carries the properties[...] name.
  //
  // The per-slot boxes are pure UI — their combined value goes to the hidden
  // output — so they go through window.ccNeverSubmit instead.
  function markSlotInput(el, index) {
    window.ccNeverSubmit(el, 'cc-engraving-slot-' + (index + 1));
  }

  /* ── Single mode ─────────────────────────────── */
  if (!multi) {
    var input = root.querySelector('[data-cc-engraving-input]');
    var counter = root.querySelector('[data-cc-counter]');

    input.addEventListener('input', function () {
      var filtered = filterValue(this.value);
      // Enforce here as well as via the maxlength attribute: maxlength only
      // constrains typing and pasting, so autofill or any programmatic write
      // could otherwise leave more characters in the box — and in the cart —
      // than the chosen variant paid for. It also cannot express the
      // letters-vs-bonus split at all. Budgets are live, updated below
      // whenever the count option changes.
      filtered = enforceBudget(filtered);
      if (filtered !== this.value) {
        // Preserve the caret: forcing case rewrites the whole value, and
        // assigning .value would otherwise jump the cursor to the end mid-word.
        var at = this.selectionStart;
        this.value = filtered;
        try { this.setSelectionRange(at, at); } catch (e) {}
      }
      setCounterState(counter, this.value.length);
      window.ccSubmitWhenFilled(this);
      dispatch([this.value]);
    });

    // ── maxlength driven by a variant option ──
    // Only wired when the block asked for it. The listener is delegated on
    // document rather than bound to the radios themselves so it survives the
    // theme re-rendering the option block on a variant change.
    if (maxCharsAxis) {
      var axisField = 'options[' + maxCharsAxis + ']';
      // Quoted attribute selector, so the option name needs no CSS escaping —
      // only the quote/backslash characters that would close the string early.
      var axisSel = axisField.replace(/(["\\])/g, '\\$1');

      // ATELIER ADAPTATION. Pipeline exposes each axis as native
      // input[name="options[...]"] radios, which is what the reads below use.
      // Atelier renders its axes as pill buttons from cc-variant-switcher.js and
      // has NO native option controls at all — the only DOM record of the current
      // selection is the hidden variant id. So when the native read finds
      // nothing, resolve the axis value from the SELECTED VARIANT via the
      // product JSON. That path is correct on both themes; the native read is
      // kept first so Pipeline behaviour is untouched.
      var ccProductJson = null;
      try {
        var pjEl = document.querySelector('[data-cc-product-json]');
        if (pjEl) ccProductJson = JSON.parse(pjEl.textContent);
      } catch (e) { ccProductJson = null; }
      var ccIdInput = document.querySelector('input[name="id"]');

      var readAxisFromVariant = function () {
        if (!ccProductJson || !ccIdInput) return null;
        var names = ccProductJson.options || [];
        var idx = -1;
        for (var oi = 0; oi < names.length; oi++) {
          var nm = (names[oi] && names[oi].name) ? names[oi].name : names[oi];
          if (nm === maxCharsAxis) { idx = oi; break; }
        }
        if (idx < 0) return null;
        var vid = parseInt(ccIdInput.value, 10);
        var vs = ccProductJson.variants || [];
        for (var vi = 0; vi < vs.length; vi++) {
          if (vs[vi].id === vid) return (vs[vi].options || [])[idx];
        }
        return null;
      };

      var readAxisMax = function () {
        var checked = document.querySelector('input[name="' + axisSel + '"]:checked');
        var select = checked ? null : document.querySelector('select[name="' + axisSel + '"]');
        var raw = checked ? checked.value : (select ? select.value : null);
        if (raw === null || raw === undefined) raw = readAxisFromVariant();
        var n = parseInt(raw, 10);
        if (isNaN(n) || n < 1) return maxCharsCeiling;
        return Math.min(n + maxCharsBonus, maxCharsCeiling);
      };

      var applyAxisMax = function () {
        var next = readAxisMax();
        var box = root.querySelector('[data-cc-engraving-input]');
        var count = root.querySelector('[data-cc-counter]');
        if (!box || !count) return;
        maxChars = next;
        box.maxLength = maxChars;
        // Re-spend the budget at the new count — dropping to a smaller count
        // must never leave more characters in the cart than the shopper is
        // paying for. Uses the same split as typing, so lowering the count
        // drops surplus letters while keeping the clasp dash.
        var rebudgeted = enforceBudget(box.value);
        if (rebudgeted !== box.value) box.value = rebudgeted;
        setCounterState(count, box.value.length);
        window.ccSubmitWhenFilled(box);
        dispatch([box.value]);
      };

      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.name || t.name !== axisField) return;
        applyAxisMax();
      });

      // ATELIER ADAPTATION. No native option control means no `change` event to
      // listen for, so watch the hidden variant id — the one thing every axis
      // change updates on this theme. Same 300ms poll the Pipeline bridge uses
      // for the same reason. Only armed when there is no native control.
      if (ccIdInput && !document.querySelector('input[name="' + axisSel + '"], select[name="' + axisSel + '"]')) {
        var ccLastId = ccIdInput.value;
        setInterval(function () {
          if (ccIdInput.value === ccLastId) return;
          ccLastId = ccIdInput.value;
          applyAxisMax();
        }, 300);
      }

      applyAxisMax();
      return;
    }

    window.ccSubmitWhenFilled(input);
    dispatch([input.value]);
    return;
  }

  /* ── Count-first mode (pick N → N required boxes, drives variant) ── */
  if (root.hasAttribute('data-count-first')) {
    initCountFirst();
    return;
  }

  /* ── Multi-slot mode ─────────────────────────── */
  var slotsContainer = root.querySelector('[data-cc-slots]');
  var addBtn = root.querySelector('[data-cc-add-slot]');
  var output = root.querySelector('[data-cc-engraving-output]');

  var values = [];
  for (var i = 0; i < minSlots; i++) values.push('');

  function syncOutput() {
    // Alex's numbered format, same as count-first mode below: one property per
    // filled box, in slot order, numbered only when there is more than one.
    // This "+ Add another" mode is still a LIST OF NAMES, so it would otherwise
    // keep exactly the space-joined ambiguity the numbered format removes.
    var baseLabel = (prefix && prefix !== 'Slot') ? prefix : property;
    window.ccWriteNumberedProps(root, baseLabel, values.map(function (v) { return v.trim(); }));
    window.ccRetireJoinedInput(output);
    dispatch(values);
  }

  function buildRow(index) {
    var row = document.createElement('div');
    row.className = 'cc-text-engraving__slot';

    var input = document.createElement('input');
    input.type = 'text';
    input.className = 'cc-text-engraving__input';
    input.placeholder = prefix + ' ' + (index + 1);
    input.maxLength = maxChars;
    input.autocomplete = 'off';
    input.value = values[index];
    input.setAttribute('aria-label', prefix + ' ' + (index + 1));
    markSlotInput(input, index);

    var counter = document.createElement('p');
    counter.className = 'cc-text-engraving__counter cc-text-engraving__counter--slot';
    setCounterState(counter, values[index].length);

    if (values[index] !== '') row.classList.add('has-content');

    input.addEventListener('input', function () {
      var filtered = filterValue(this.value);
      if (filtered !== this.value) this.value = filtered;
      values[index] = this.value;
      setCounterState(counter, this.value.length);
      row.classList.toggle('has-content', this.value !== '');
      syncOutput();
    });
    input.addEventListener('focus', function () { row.classList.add('is-focused'); });
    input.addEventListener('blur', function () { row.classList.remove('is-focused'); });

    var field = document.createElement('div');
    field.className = 'cc-text-engraving__field';
    field.appendChild(input);
    field.appendChild(counter);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'cc-text-engraving__remove';
    removeBtn.textContent = 'Remove';
    removeBtn.setAttribute('aria-label', 'Remove ' + prefix.toLowerCase() + ' ' + (index + 1));
    removeBtn.hidden = values.length <= minSlots;
    removeBtn.addEventListener('click', function () {
      values.splice(index, 1);
      render();
      syncOutput();
    });

    row.appendChild(field);
    row.appendChild(removeBtn);
    return row;
  }

  function render() {
    slotsContainer.innerHTML = '';
    values.forEach(function (_, i) {
      slotsContainer.appendChild(buildRow(i));
    });
    // Absent when the slot count is fixed (max_slots == min_slots) — the snippet
    // omits the button entirely rather than shipping one that can never fire.
    if (addBtn) addBtn.hidden = values.length >= maxSlots;
  }

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (values.length >= maxSlots) return;
      values.push('');
      render();
      syncOutput();
      var inputs = slotsContainer.querySelectorAll('input');
      inputs[inputs.length - 1].focus();
    });
  }

  render();
  syncOutput();

  /* ── Count-first mode implementation ─────────────────────────── */
  // Pick N (from a variant option's values) → N required text boxes. The count
  // drives the "Material / N" variant axis via cc:engraving-changed (count stays
  // 0 until every box is filled, so ATC gates on all-N-required). Names are
  // space-joined into one property. Mirrors the initial picker's count model.
  function initCountFirst() {
    var countSelector = root.querySelector('[data-cc-count-selector]');
    var slotsContainer = root.querySelector('[data-cc-slots]');
    var output = root.querySelector('[data-cc-engraving-output]');
    var gateMsg = root.querySelector('[data-cc-engraving-gatemsg]');

    var values = [];
    var count = 0;

    // Single-count products (only one count offered) skip the selector.
    var singleCount = parseInt(root.dataset.ccEngravingCount, 10);
    if (singleCount > 0) {
      count = singleCount;
      while (values.length < count) values.push('');
    }

    function isComplete() {
      return count > 0 && values.every(function (v) { return v.trim() !== ''; });
    }

    function emit() {
      var complete = isComplete();
      // count/filled stay 0 until ALL boxes are filled → all-N-required gate.
      // selectedCount is the picked N, for the switcher's price preview.
      document.dispatchEvent(new CustomEvent('cc:engraving-changed', {
        detail: {
          property: property,
          label: label,
          values: values.slice(),
          filled: complete ? count : 0,
          count: complete ? count : 0,
          selectedCount: count,
          min: 1,
          required: true
        }
      }));
    }

    function syncOutput() {
      // Alex's numbered format: one property per filled box, in slot order.
      //   2+  properties[Name 1] = "Jo Ann", properties[Name 2] = "Mary"
      //   1   properties[Name]   = "Jo Ann"
      // `prefix` is the block's own singular slot noun (slot_placeholder_prefix,
      // e.g. "Name"), which is exactly the base label Alex asked for; it falls
      // back to the property name if a product never set one. The old joined
      // output input is retired in place — see ccRetireJoinedInput.
      //
      // Single-name products use SINGLE mode above, not this one, so they keep
      // their existing one-property behaviour untouched.
      var baseLabel = (prefix && prefix !== 'Slot') ? prefix : property;
      window.ccWriteNumberedProps(root, baseLabel, values.map(function (v) { return v.trim(); }));
      window.ccRetireJoinedInput(output);

      if (gateMsg) {
        if (count > 0 && !isComplete()) {
          var noun = count === 1 ? prefix.toLowerCase() : prefix.toLowerCase() + 's';
          gateMsg.hidden = false;
          gateMsg.textContent = count === 1
            ? 'Enter the ' + noun + ' to continue.'
            : 'Enter all ' + count + ' ' + noun + ' to continue.';
        } else {
          gateMsg.hidden = true;
        }
      }
      emit();
    }

    function buildRow(index) {
      var row = document.createElement('div');
      row.className = 'cc-text-engraving__slot';

      var input = document.createElement('input');
      input.type = 'text';
      input.className = 'cc-text-engraving__input';
      input.placeholder = prefix + ' ' + (index + 1);
      input.maxLength = maxChars;
      input.autocomplete = 'off';
      input.value = values[index];
      input.setAttribute('aria-label', prefix + ' ' + (index + 1));
      input.setAttribute('aria-required', 'true');
      markSlotInput(input, index);

      var counter = document.createElement('p');
      counter.className = 'cc-text-engraving__counter cc-text-engraving__counter--slot';
      setCounterState(counter, values[index].length);

      if (values[index] !== '') row.classList.add('has-content');

      input.addEventListener('input', function () {
        var filtered = filterValue(this.value);
        if (filtered !== this.value) this.value = filtered;
        values[index] = this.value;
        setCounterState(counter, this.value.length);
        row.classList.toggle('has-content', this.value.trim() !== '');
        syncOutput();
      });
      input.addEventListener('focus', function () { row.classList.add('is-focused'); });
      input.addEventListener('blur', function () { row.classList.remove('is-focused'); });

      var field = document.createElement('div');
      field.className = 'cc-text-engraving__field';
      field.appendChild(input);
      field.appendChild(counter);
      row.appendChild(field);
      return row;
    }

    function renderSlots() {
      slotsContainer.innerHTML = '';
      values.forEach(function (_, i) {
        slotsContainer.appendChild(buildRow(i));
      });
    }

    function renderCountSelector() {
      if (!countSelector) return;
      countSelector.querySelectorAll('[data-cc-count]').forEach(function (btn) {
        var on = parseInt(btn.dataset.ccCount, 10) === count;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function setCount(n) {
      if (n === count) return;
      if (n < count) {
        values = values.slice(0, n);      // lowering N drops the trailing boxes
      } else {
        while (values.length < n) values.push('');
      }
      count = n;
      renderCountSelector();
      renderSlots();
      syncOutput();
    }

    if (countSelector) {
      countSelector.querySelectorAll('[data-cc-count]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          setCount(parseInt(this.dataset.ccCount, 10));
        });
      });
    }

    renderCountSelector();
    renderSlots();
    syncOutput();
  }
})();
